module.exports = __webpack_public_path__ + "maior-navio-de-cruzeiro.f2be46d3016d06a93ab0cae0f4765821.jpg";